// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend-legend-tgR0o"};